module.exports = __webpack_public_path__ + "static/img/img-14.ba87bc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/i/img-14.jpg
// module id = 97
// module chunks = 0